import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCta() {
  return <section className="bg-brand-darker py-16 sm:py-20 lg:py-28 px-5 sm:px-6" data-id="element-18">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-19">
        <h2 className="text-[26px] sm:text-[32px] md:text-[40px] font-bold text-brand-cream mb-5 sm:mb-6 leading-tight" data-id="element-20">
          Votre LinkedIn peut commencer à travailler pour vous dès cette
          semaine.
        </h2>

        <p className="text-[16px] sm:text-[18px] md:text-[20px] text-brand-cream/80 mb-8 sm:mb-10 max-w-2xl" data-id="element-21">
          3 à 5 jours. Un profil professionnel, stratégique, qui reflète enfin
          votre vraie valeur.
        </p>

        <a href="https://wa.me/15148095007?text=Bonjour%20Rebeca%2C%20je%20suis%20pr%C3%AAt(e)%20%C3%A0%20transformer%20mon%20LinkedIn" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-brand-gold text-brand-black font-bold text-[15px] sm:text-[18px] px-6 sm:px-12 py-4 sm:py-[18px] rounded-[4px] hover:bg-white transition-colors duration-300 mb-5 sm:mb-6 group w-full sm:w-auto text-center" data-id="element-22">
          <ArrowRight className="w-5 h-5 mr-2 group-hover:translate-x-1 transition-transform shrink-0" data-id="element-23" />
          Écrire à Rebeca sur WhatsApp
        </a>

        <p className="text-[13px] sm:text-[14px] text-brand-cream/60 mb-8 sm:mb-10" data-id="element-24">
          Aucun engagement. Juste une conversation.
          <br className="sm:hidden" data-id="element-25" /> Je réponds en moins de 24h. ✦
        </p>

        <div className="w-[80px] h-[1px] bg-brand-gold/30 my-8 sm:my-10" data-id="element-26"></div>

        <p className="text-[14px] sm:text-[16px] text-brand-cream/70 italic" data-id="element-27">
          Vous avez travaillé fort pour bâtir votre expertise.
          <br className="sm:hidden" data-id="element-28" /> Il est temps que votre LinkedIn le
          montre. ✦
        </p>
      </motion.div>
    </section>;
}